module.exports = __webpack_public_path__ + "16c39dac.svg";